import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface ISaveBillBeneficiaryRequest {
  customerId: string; //Phone Number if it's data, decoder number if DSTV
  billerName: string;
  billCategory: string;
  billerId: string;
  billItemId: string;
  alias: string;
}

interface ISaveBillBeneficiaryResponse {
  status?: boolean;
  message?: string;
  data?: unknown;
  errors?: IApiResponseError[];
}

const initialState: IApiState<ISaveBillBeneficiaryResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const saveBillBeneficiaryAsync = createAsyncThunk(
  'saveBillBeneficiary',
  async (
    values: ISaveBillBeneficiaryRequest,
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };

      const { data } = await api.post(
        '/billpayment/beneficiaries/create',
        values,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<ISaveBillBeneficiaryResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const billBeneficiaryCreationSlice = createSlice({
  name: 'saveBillBeneficiary',
  initialState,
  reducers: {
    resetBillBeneficiaryCreation(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveBillBeneficiaryAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(saveBillBeneficiaryAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as ISaveBillBeneficiaryResponse;
      })
      .addCase(saveBillBeneficiaryAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as ISaveBillBeneficiaryResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetBillBeneficiaryCreation } =
  billBeneficiaryCreationSlice.actions;

export default billBeneficiaryCreationSlice.reducer;
